
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import ResetRequestForm from "./ResetRequestForm";
import PasswordUpdateForm from "./PasswordUpdateForm";
import ResetConfirmation from "./ResetConfirmation";

const PasswordResetForm = ({ onCancel }: { onCancel: () => void }) => {
  const [searchParams] = useSearchParams();
  
  // Check both our previous parameter and Supabase's auth redirect parameters
  // type=recovery is the Supabase standard parameter for password reset
  const isReset = searchParams.get("reset") === "true" || 
                  searchParams.get("type") === "recovery";
                  
  const [email, setEmail] = useState("");
  const [resetSent, setResetSent] = useState(false);
  const [resetComplete, setResetComplete] = useState(false);
  
  // Handle success from the request form
  const handleResetRequestSuccess = (emailAddress: string) => {
    setEmail(emailAddress);
    setResetSent(true);
  };
  
  // Handle success from the update form
  const handlePasswordUpdateSuccess = () => {
    setResetComplete(true);
  };
  
  // Debug URL parameters if needed
  console.log("URL params:", Object.fromEntries(searchParams.entries()));
  console.log("Is reset mode:", isReset);
  
  if (resetComplete) {
    return <ResetConfirmation type="complete" onDone={onCancel} />;
  }
  
  if (isReset) {
    // Show password update form for users who clicked the reset link
    return (
      <PasswordUpdateForm 
        onSuccess={handlePasswordUpdateSuccess} 
        onCancel={onCancel} 
      />
    );
  }
  
  if (resetSent) {
    // Show confirmation message after sending reset email
    return (
      <ResetConfirmation 
        type="sent" 
        email={email} 
        onDone={onCancel} 
      />
    );
  }
  
  // Show initial password reset request form
  return (
    <ResetRequestForm 
      onSuccess={handleResetRequestSuccess} 
      onCancel={onCancel} 
    />
  );
};

export default PasswordResetForm;
